import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
let WInput = class WInput extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "inputRef", void 0);
    _defineProperty(this, "icon", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "enabled", void 0);
    _defineProperty(this, "placeholder", void 0);
    _defineProperty(this, "clearable", void 0);
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "required", void 0);
    _defineProperty(this, "type", void 0);
    // can be text, textarea, number or other
    _defineProperty(this, "maxlength", void 0);
    _defineProperty(this, "showWordLimit", void 0);
    _defineProperty(this, "rows", void 0);
    _defineProperty(this, "noPrefix", void 0);
    _defineProperty(this, "noAppend", void 0);
    _defineProperty(this, "readonly", void 0);
    _defineProperty(this, "resize", void 0);
    _defineProperty(this, "autoResize", void 0);
    _defineProperty(this, "autoResizeAdditionalGap", void 0);
    _defineProperty(this, "dataTest", void 0);
    _defineProperty(this, "realValue", "");
    _defineProperty(this, "inputResizeReferer", null);
    _defineProperty(this, "inputWidth", '');
  }
  mounted() {
    this.realValue = this.value;
    if (this.autoResize) {
      this.inputWidth = this.computeInputWidth();
    }
  }
  onChange() {
    this.$emit('changeInput', this.realValue);
  }
  onBlur() {
    this.$emit('inputBlur', this.realValue);
  }
  onChangeValue() {
    if (this.autoResize) {
      this.inputWidth = this.computeInputWidth();
    }
    this.$emit('input', this.realValue);
  }
  onChangePropValue() {
    this.realValue = this.value;
  }
  onInputResizeGapChanged() {
    if (this.autoResize) {
      this.inputWidth = this.computeInputWidth();
    }
  }
  focus() {
    this.$refs[this.inputRef]?.focus();
  }
  computeInputWidth() {
    const elInputRoot = this.$refs[this.inputRef]?.$el;
    const input = elInputRoot?.querySelector('input');
    if (elInputRoot && input && this.autoResize) {
      const elWrapper = elInputRoot.querySelector(".el-input__wrapper");
      const inputPadding = !elWrapper ? 0 : parseFloat(window.getComputedStyle(elWrapper).paddingLeft) + parseFloat(window.getComputedStyle(elWrapper).paddingRight);
      if (!this.inputResizeReferer) {
        this.inputResizeReferer = document.createElement("span");
        this.inputResizeReferer.style.position = "fixed";
        this.inputResizeReferer.style.visibility = "hidden";
        this.inputResizeReferer.style.whiteSpace = "pre";
        document.body.appendChild(this.inputResizeReferer);
      }
      const styles = window.getComputedStyle(input);
      this.inputResizeReferer.style.fontSize = styles.fontSize;
      this.inputResizeReferer.style.fontFamily = styles.fontFamily;
      this.inputResizeReferer.style.fontWeight = styles.fontWeight;
      this.inputResizeReferer.textContent = this.realValue || '';
      return `${Math.ceil(this.inputResizeReferer.getBoundingClientRect().width + inputPadding + this.autoResizeAdditionalGap)}px`;
    }
    return '';
  }
};
__decorate([Prop({
  default: 'inputRef'
})], WInput.prototype, "inputRef", void 0);
__decorate([Prop({
  default: ''
})], WInput.prototype, "icon", void 0);
__decorate([Prop({
  default: 'default'
})], WInput.prototype, "size", void 0);
__decorate([Prop({
  default: true
})], WInput.prototype, "enabled", void 0);
__decorate([Prop({
  default: ''
})], WInput.prototype, "placeholder", void 0);
__decorate([Prop({
  default: false
})], WInput.prototype, "clearable", void 0);
__decorate([Prop({
  default: ''
})], WInput.prototype, "value", void 0);
__decorate([Prop({
  default: false
})], WInput.prototype, "required", void 0);
__decorate([Prop({
  default: 'text'
})], WInput.prototype, "type", void 0);
__decorate([Prop({
  default: ''
})], WInput.prototype, "maxlength", void 0);
__decorate([Prop({
  default: false
})], WInput.prototype, "showWordLimit", void 0);
__decorate([Prop({
  default: 2
})], WInput.prototype, "rows", void 0);
__decorate([Prop({
  default: false
})], WInput.prototype, "noPrefix", void 0);
__decorate([Prop({
  default: true
})], WInput.prototype, "noAppend", void 0);
__decorate([Prop({
  default: false
})], WInput.prototype, "readonly", void 0);
__decorate([Prop()], WInput.prototype, "resize", void 0);
__decorate([Prop({
  default: false
})], WInput.prototype, "autoResize", void 0);
__decorate([Prop({
  default: 0
})], WInput.prototype, "autoResizeAdditionalGap", void 0);
__decorate([Prop()], WInput.prototype, "dataTest", void 0);
__decorate([Watch('realValue')], WInput.prototype, "onChangeValue", null);
__decorate([Watch('value')], WInput.prototype, "onChangePropValue", null);
__decorate([Watch('autoResize'), Watch('autoResizeAdditionalGap')], WInput.prototype, "onInputResizeGapChanged", null);
WInput = __decorate([Component({
  emits: ['changeInput', 'input', 'inputBlur']
})], WInput);
export default WInput;